<div class="d-flex h-100">
  <div
    class="sap-employee-popup m-auto d-flex flex-column"
    (click)="$event.stopPropagation()">
    <div class="d-flex align-items-center udex-mb-24">
      <span class="heading__bold--xs">
        {{ 'common.sapEmployeePopup.title' | cxTranslate }}
      </span>
      <udex-control-button
        class="udex-ms-auto"
        [tabindex]="0"
        (click)="confirm()"
        (keyup.enter)="confirm()"
        icon="decline"
        size="Small"
        accessible-role="Button">
      </udex-control-button>
    </div>

    <p class="body--m udex-mb-8">{{ 'common.sapEmployeePopup.line1' | cxTranslate }}</p>
    <p class="body--m udex-mb-8">
      <strong>{{ 'common.sapEmployeePopup.line2' | cxTranslate }}</strong>
    </p>

    <p class="body--m udex-mb-24">{{ 'common.sapEmployeePopup.line3' | cxTranslate }}</p>

    <udex-button
      class="align-self-start"
      (click)="confirm()"
      size="Large"
      design="Primary"
      data-cy="sap-employee-confirm-btn">
      {{ 'common.sapEmployeePopup.confirm' | cxTranslate }}
    </udex-button>
  </div>
</div>
